import type { JSX, PropsWithChildren } from 'react'

import styles from './EmptyStateBanner.module.css'

function EmptyStateBannerRoot({
  children,
  'aria-labelledby': labelledBy,
}: PropsWithChildren<{ 'aria-labelledby': string }>): JSX.Element {
  return (
    <section className={styles.banner} aria-labelledby={labelledBy}>
      {children}
    </section>
  )
}

function EmptyStateBannerContent({ children }: PropsWithChildren): JSX.Element {
  return <div className={styles.content}>{children}</div>
}

function EmptyStateBannerActions({ children }: PropsWithChildren): JSX.Element {
  return <div className={styles.actions}>{children}</div>
}

function EmptyStateBannerDecorations({
  children,
}: PropsWithChildren): JSX.Element {
  return (
    <div className={styles.decorations} aria-hidden>
      {children}
    </div>
  )
}

function EmptyStateBannerDecoration({
  children,
}: PropsWithChildren): JSX.Element {
  return <span className={styles.chip}>{children}</span>
}

export const EmptyStateBanner = Object.assign(EmptyStateBannerRoot, {
  Content: EmptyStateBannerContent,
  Actions: EmptyStateBannerActions,
  Decorations: EmptyStateBannerDecorations,
  Decoration: EmptyStateBannerDecoration,
})
